/* ORTEVA VELIA · tasarım demo hareket katmanı
   ui-ux-pro-max motion presetleri (Scroll Reveal Standard, Stagger ≤8) vanilla IntersectionObserver ile.
   JS çalışmazsa hiçbir içerik gizli kalmaz: gizleme yalnızca bu dosyanın eklediği [data-rv] ile olur. */
(function(){
  var kok = document.documentElement;
  if (!kok.classList.contains('va') || !('IntersectionObserver' in window)) return;
  var $$ = function(s, k){ return Array.prototype.slice.call((k || document).querySelectorAll(s)); };

  /* 1 · Gözlemci: görünür olunca rv-on */
  var io = new IntersectionObserver(function(girdiler){
    girdiler.forEach(function(g){
      if (!g.isIntersecting) return;
      var el = g.target; io.unobserve(el);
      if (el.__grup) { el.__grup.forEach(function(c){ c.classList.add('rv-on'); }); }
      else el.classList.add('rv-on');
      if (el.__sonra) el.__sonra();
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

  function tek(el, tur){
    if (!el || el.closest('#urun') || el.hasAttribute('data-rv')) return;
    el.setAttribute('data-rv', tur || '');
    io.observe(el);
  }
  function grup(kap, tur){
    if (!kap || kap.closest('#urun')) return;
    var cocuk = Array.prototype.slice.call(kap.children).filter(function(c){ return !c.hidden && c.tagName !== 'SCRIPT' && c.tagName !== 'STYLE'; });
    if (!cocuk.length) return;
    cocuk.forEach(function(c, i){ c.setAttribute('data-rv', tur || ''); c.style.setProperty('--rv-i', Math.min(i, 7)); });
    kap.__grup = cocuk; io.observe(kap);
  }

  /* 2a · Başlıkları kelimelere böl (yalnızca düz metinli başlıklar) */
  $$('main .h2, main h2, .ty__h2').forEach(function(h){
    if (h.closest('#urun, .kart, .an, .ty__kart, .tk, details, .son') || h.children.length) return;
    var w = h.textContent.trim().split(/\s+/); if (!w.length || w.length > 12) return;
    h.setAttribute('aria-label', h.textContent.trim());
    h.innerHTML = w.map(function(x, i){ return '<span class="vd-kelime" aria-hidden="true" style="--k:' + i + '">' + x.replace(/[&<>]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;'}[c]; }) + '</span>'; }).join(' ');
    h.classList.add('vd-baslik');
  });

  /* 2 · Bölüm başlıkları */
  $$('main .eyebrow, main .h2, main h2, main .lead, .ty__eyebrow, .ty__lead, .ty__kaynak').forEach(function(el, i){
    if (el.closest('.kart, .an, .ty__kart, .son, .tk, details')) return;
    tek(el);
  });

  /* 3 · Kart ızgaraları ve raylar (yatay raylar kapsayıcıdan tetiklenir) */
  $$('.kartlar, .anlar, .kul__adimlar, .rg__ray, .set__ray, .vid__ray, .ty-duvar, .ty__kartlar, .tikler, .kargo, .sss, .nicin__guven').forEach(function(k){ grup(k); });

  /* 4 · Tekil bloklar: büyük fotoğraflar perde gibi açılır */
  $$('.kul__gorsel, .guv__gorsel').forEach(function(el){ tek(el, 'perde'); });
  $$('.detay img').forEach(function(el){ tek(el, 'sol'); });
  $$('.son, .kars, .nicin__alt').forEach(function(el){ tek(el); });

  /* 5 · Puan özeti: sayı sayar, yıldız ve çubuklar dolar */
  $$('.ty__ozet').forEach(function(oz){
    tek(oz, 'olcek');
    var puan = oz.querySelector('.ty__puan'), dolu = oz.querySelector('.ty__dolu');
    var cubuk = $$('.ty__bar b', oz);
    var hedefG = cubuk.map(function(b){ return b.style.width; });
    var hedefD = dolu ? dolu.style.width : null;
    cubuk.forEach(function(b){ b.style.transition = 'width 1.1s cubic-bezier(.22,1,.36,1)'; b.style.width = '0%'; });
    if (dolu) { dolu.style.transition = 'width 1.2s cubic-bezier(.22,1,.36,1)'; dolu.style.width = '0%'; }
    var metin = puan ? puan.textContent.trim() : '', ay = metin.indexOf(',') > -1 ? ',' : '.';
    var hedef = parseFloat(metin.replace(',', '.'));
    oz.__sonra = function(){
      setTimeout(function(){
        cubuk.forEach(function(b, i){ setTimeout(function(){ b.style.width = hedefG[i]; }, i * 90); });
        if (dolu) dolu.style.width = hedefD;
        if (puan && !isNaN(hedef)) {
          var t0 = null, sure = 1100;
          (function kare(t){
            if (!t0) t0 = t; var p = Math.min(1, (t - t0) / sure), e = 1 - Math.pow(1 - p, 3);
            puan.textContent = (hedef * e).toFixed(1).replace('.', ay);
            if (p < 1) requestAnimationFrame(kare); else puan.textContent = metin;
          })(performance.now());
        }
      }, 180);
    };
  });

  /* 6 · Paralaks (hafif, ±22px) */
  var plx = $$('.kul__gorsel, .guv__gorsel');
  plx.forEach(function(el){ el.setAttribute('data-plx', ''); el.style.overflow = 'hidden'; });
  var bekliyor = false;
  function plxGuncelle(){
    bekliyor = false; var vh = window.innerHeight;
    plx.forEach(function(el){
      var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var d = (r.top + r.height / 2 - vh / 2) * -0.06;
      el.style.setProperty('--plx', Math.max(-22, Math.min(22, d)).toFixed(1) + 'px');
    });
  }
  if (plx.length) { window.addEventListener('scroll', function(){ if (!bekliyor) { bekliyor = true; requestAnimationFrame(plxGuncelle); } }, { passive: true }); plxGuncelle(); }

  /* 7 · Paket seçimi: halka nabzı; fiyat değişince rakam yukarı kayar */
  $$('input[name="th-paket"]').forEach(function(r){
    r.addEventListener('change', function(){
      var l = r.closest('.paket'); if (!l) return;
      l.classList.remove('vd-nabiz'); void l.offsetWidth; l.classList.add('vd-nabiz');
    });
  });
  function tik(el){ el.classList.remove('vd-tik'); void el.offsetWidth; el.classList.add('vd-tik'); }
  if ('MutationObserver' in window) {
    $$('[data-toplam], [data-altbar-fiyat], [data-cta-tutar]').forEach(function(el){
      var son = el.textContent;
      new MutationObserver(function(){ if (el.textContent !== son) { son = el.textContent; tik(el); } }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* 8 · Sepete eklenince sepet ikonu zıplar (fetch yalnızca izlenir, değiştirilmez) */
  if (window.fetch) {
    var asil = window.fetch;
    window.fetch = function(u){
      var p = asil.apply(this, arguments);
      try {
        var adres = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/add/.test(adres)) p.then(function(r){ if (r && r.ok) $$('.sepet-ik').forEach(function(s){ s.classList.remove('vd-zipla'); void s.offsetWidth; s.classList.add('vd-zipla'); }); }).catch(function(){});
      } catch(e){}
      return p;
    };
  }

  /* Emniyet: gözlemci hiç tetiklenmezse 6 sn sonra ekrandakileri göster */
  setTimeout(function(){
    $$('[data-rv]:not(.rv-on)').forEach(function(el){ var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('rv-on'); });
  }, 6000);
})();
